module.exports = __webpack_public_path__ + "img/logo.583a7dec.png";